import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataStoreService {

  public parentID;
  public selectedLocationID;

  public language;

  // Variable to hold selected location
  public selectedLocation;
  // Variable to hold client details object
  public clientDetails;
  // Variable to hold application details
  public applicationDetails;
  // Holds the current basket
  public basketItems = [];
  // Keeps the checkout data for confirmation
  public checkoutData;
  // service total holds the price of the booking for 'Your booking card'

  // The below are saved here becouse the sidebar uses them throughout, Needs to be a single compo \\
  public serviceTotal;

  public total;

  // object to store dobs for applicants
  public applicantDateOfBirths = {};

  // Holds the applicant array from the applicant details page
  public applicantArrayCopy;
  // Holds service selected from applicant details;
  public selectedService;
  // All booking questions
  public bookingQuestion;
  // Holds the service
  public service;

  public servicesAvailibility = [];

  public applicantArray;

  public passportFeeArray = [];

  // store country details for booking client
  public countryDetails;

  public irishAddress;

  selectedServiceAvailibility: any[];

  public counters: any[];

  public dynamicForm;

  public paymentResponse;

  // The order ID as sent to Elavon (including random identifier)
  public realOrderId;

  // The count of payment retries in this session
  public paymentRetryCount;

  public purchase;

  public client;

  notify: Subject<boolean> = new Subject<boolean>();
  onNotify(event) {
    this.notify.next(true);
  }

  constructor() { }
}
